<template>
    <div class="text-xs">
        Before using the application you must first agree to our Terms &amp;
        Conditions.
        <span
            class="text-primaryBlue-100 cursor-pointer"
            @click="
                $modal.show('read-terms-modal', {
                    data: {},
                })
            "
            >Click here to read</span
        >.
    </div>
</template>

<script>
export default {
    props: [],
};
</script>

<style></style>
